<template>
  <!-- :key="$route.fullPath" is used to force replacement of an element/component 
  with same route but have different params -->
  <div>
    <oba-header />
    <div class="app-container">
      <router-view ></router-view>
    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
import firebaseInit from './firebaseConf'
import header from './components/header'

import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import { createNamespacedHelpers } from "vuex"
import { showNotification, setupAuthListener } from '@/lib/utils'

const { mapMutations: mapMutationUser } = createNamespacedHelpers("user")

export default {
  name: 'App',
  components: {
    'oba-header': header
  },
  methods: {
    ...mapMutationUser({
      saveUserInfo: "SAVE_USER_INFO",
    }),
  },
  mounted() {
    M.AutoInit()
    firebaseInit()
    setupAuthListener()

    window.addEventListener('offline', () => {
      showNotification('error', 'Internet connection is lost. Please check your network before saving data.');
    })

    window.addEventListener('online', () => {
      showNotification('success', 'The internet connection is stable again.');
    })

  },
  beforeUnmount() {
    window.removeEventListener('offline', () => {});
    window.removeEventListener('online', () => {});
  },
}
</script>